module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/自动激光镭码机.2d56786f.png";